// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3zAm8","imageUploader":"EGiftCard_imageUploader__p21r-"};